import DressageLines from "./DressageLines";

export default class DressageStep {
  constructor(private readonly _index: number,
              private readonly _imageUrl: string | undefined,
              private readonly _dressageLines: DressageLines) {
  }

  get index(): number {
    return this._index;
  }

  get imageUrl(): string | undefined {
    return this._imageUrl;
  }

  get dressageLines(): DressageLines {
    return this._dressageLines;
  }
}
